import {Adapter} from "./person-autocomplete.component";
import {Observable} from "rxjs";
import {Pageable} from "../../model/rest/base";
import {map} from "rxjs/operators";
import {StudentV3RestService} from "../../services/rest/v3/student-rest.service";
import {V3Student, V3Teacher} from "../../model/v3/schools";
import {ManagerUtils} from "../../services/utils/v3/manager-utils";
import {TeacherV3RestService} from "../../services/rest/v3/teacher-rest.service";

/**
 * Adapter which provides autocomplete entries basing on the provided term
 * Base adapter for student and teacher as they have very similar structure and
 * most of the code may be shared
  */
abstract class PersonAutocompleteAdapterBase<T extends V3Student | V3Teacher> implements Adapter<T> {
  abstract dataProvider(term: string): Observable<T[]>;

  mapper(item: T) {
    return ManagerUtils.getName(item.person);
  }

  detailsMapper(item: T) {
    if (!item || !item.person.registrationEmail) return null;
    return item.person.registrationEmail;
  }
}

/**
 * Student's specific autocomplete adapter
 */
export class StudentAutocompleteAdapter extends PersonAutocompleteAdapterBase<V3Student> {

  constructor(
    private schoolId: number,
    private studentV3Rest: StudentV3RestService
  ) {
    super();
  }

  dataProvider(term: string): Observable<V3Student[]> {
    return this.studentV3Rest.getStudents(this.schoolId, term, null, null, Pageable.of(0, 5, null)).pipe(
      map( page => page.content)
    );
  }
}

/**
 * Teacher's specific autocomplete adapter
 */
export class TeacherAutocompleteAdapter extends PersonAutocompleteAdapterBase<V3Teacher> {

  constructor(
    private schoolId: number,
    private teacherV3Rest: TeacherV3RestService
  ) {
    super();
  }

  dataProvider(term: string): Observable<V3Teacher[]> {
    return this.teacherV3Rest.findTeachers(this.schoolId, term, null, Pageable.of(0, 5, null)).pipe(
      map( page => page.content)
    );
  }
}
